export const FormClearable = (controller) => {
  Object.assign(controller, {
    clearElement: (input) => {
      if (!input || !input.tagName) {
        console.warn(
          "FormClearable.clearElement: Invalid input element provided"
        );
        return;
      }

      switch (input.tagName.toLowerCase()) {
        case "input":
          if (input.type === "checkbox" || input.type === "radio") {
            input.checked = false;
          } else {
            input.value = "";
          }
          break;
        case "select":
          if (input.options.length > 0) {
            input.selectedIndex = 0;
          }
          break;
        case "textarea":
          input.value = "";
          break;
        default:
          console.warn(
            `FormClearable.clearElement: Unsupported element type: ${input.tagName}`
          );
      }
    },
  });
};
